import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { approveItem } from '../../payment/paymentActions.js';
import Page from '../../../page.jsx';
import { data as agreementDataPropTypes } from '../../../agreementPropTypes.js';
import partnerPropTypes from '../../../partnerPropTypes.js';
import paymentPropTypes from '../../../paymentPropTypes.js';
import formatOreToKroner from '../../../../lib/formatOreToKroner.js';
import { trackEvent } from '../../../../services/trackingService.js';

class HandleTransferPaymentDetails extends PureComponent {
    componentDidMount() {
        trackEvent('trade.buyer-approves-item.buyer-approves', 'start');
    }

    render() {
        const {
            agreement,
            partner,
            payment,
            handleClickAcceptItem,
        } = this.props;
        const btnClass = classNames('order fullwidth', {
            inprogress: payment.loading,
        });

        return (
            <Page heading={`Kan ${partner.name} få pengene?`}>
                <div>
                    <p>
                        Om alt er OK, vil vi overføre{' '}
                        {formatOreToKroner(agreement.total)} til {partner.name}.
                    </p>
                    <p className="r-pbl">Kan {partner.name} få pengene?</p>

                    <div className="r-phl">
                        <button
                            onClick={handleClickAcceptItem}
                            disabled={payment.loading}
                            className={btnClass}
                        >
                            Ja, gi {partner.name} pengene
                        </button>
                    </div>
                </div>
            </Page>
        );
    }
}

HandleTransferPaymentDetails.propTypes = {
    agreement: agreementDataPropTypes.isRequired,
    itemId: PropTypes.string.isRequired,
    itemType: PropTypes.string.isRequired,
    partner: partnerPropTypes.isRequired,
    payment: paymentPropTypes.isRequired,
    handleClickAcceptItem: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        agreement: state.agreement.data,
        itemId: state.safeTrade.itemId,
        itemType: state.safeTrade.itemType,
        partner: state.partner,
        payment: state.payment,
    };
}

const mapDispatchToProps = { handleClickAcceptItem: approveItem };

function mergeProps(stateProps, dispatchProps, ownProps) {
    const { itemType, itemId, partner } = stateProps;

    return {
        ...ownProps,
        ...stateProps,
        handleClickAcceptItem: () =>
            dispatchProps.handleClickAcceptItem({
                itemType,
                itemId,
                partnerId: partner.id,
            }),
    };
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(
    HandleTransferPaymentDetails
);



// WEBPACK FOOTER //
// ./safeTrade/buyer/payment/statusDetails/handleTransferPaymentDetails.jsx